import React from 'react';
import { renderToString } from 'react-dom/server';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { Invoice, Order, User } from 'services/action';

import { Print } from 'ui/components';
import { formatDate, currencyFormat } from 'utilities/common';

import logoBlack from 'ui/assets/envio-black.png';
import logo from 'ui/assets/logos.png';

const PrintInvoice = ({ match }) => {
  const Dispatch = useDispatch();
  const SessionClient = useSelector((state) => state?.Auth?.session?.client);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Invoice.Show']
  );
  const [data, setData] = React.useState(null);
  const [orders, setOrders] = React.useState(null);
  const [client, setClient] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
  const [page, setPage] = React.useState(null);
  const [firstPage] = React.useState(14);
  const [limit] = React.useState(18);

  const $onLoad = async (id) => {
    const req = await Dispatch(Invoice.$show(id));
    if (req?.message === 'success') {
      setData(req?.data);
      $onLoadOrders(id)
      $onLoadUser();
    }
  };

  const $onLoadOrders = async (id) => {
    const req = await Dispatch(Order.$getByInvoice(id));
    if (req?.message === 'success') {
      setOrders(req?.data);
    }
  };

  const $onLoadUser = async (id) => {
    const req = await Dispatch(User.$show(SessionClient?.id));
    if (req?.message === 'success') {
      setClient(req?.data);
    }
  };

  React.useEffect(() => {
    setLoaded(false);

    $onLoad(match?.params?.id);
  }, [client]);

  React.useEffect(() => {
    if (data && orders) {
      let pages = _.chunk(orders, firstPage);
      if (orders?.length > firstPage) {
        let first = pages[0];
        let last = _.rest(orders, first?.length);
        pages = _.chunk(last, limit);
        pages.unshift(first);
      } else {
        setPage(pages);
      }

      setPage(pages);
      setLoaded(true);
    }
  }, [data, orders]);


  if (StateLoading || data === null || !loaded) return null;

  return (
    <div>
      <Print
        title={`Invoice - ${data?.code}`}
        size="A4"
        content={renderToString(
          <>
            {page?.map((p, id) => (
              <section
                className="sheet page-break"
                style={{ padding: '20px 60px' }}
                key={id}
              >

                {id === 0 && (
                  <>
                    <table className="body">
                      <tr style={{ verticalAlign: 'center' }}>
                        <td
                          style={{
                            textAlign: 'left',
                            paddingBottom: 15,
                            paddingTop: 30,
                            width: '30%',
                          }}
                        >
                          <p
                            className="mb-0"
                            style={{ fontSize: 30, fontWeight: 800 }}
                          >
                            INVOICE
                          </p>
                          <p
                            className="bold mb-0"
                            style={{ fontSize: 12, paddingTop: 10 }}
                          >
                            {client?.company_name || client?.name}
                          </p>
                          <p style={{ fontSize: 11, lineHeight: 1.5 }}>
                            {client?.address}
                          </p>
                        </td>

                        <td style={{ width: '50%', textAlign: 'right' }}>
                          <img src={client?.avatar?.replace('_thumb', '') || logoBlack} alt="" height="50px" />
                        </td>
                      </tr>
                    </table>

                    <div style={{ marginTop: 10 }}>
                      <table className="body ">
                        <tr style={{ verticalAlign: 'top' }}>
                          <td
                            style={{
                              textAlign: 'left',
                              width: '40%',
                              padding: 10,
                              paddingLeft: 0,
                            }}
                          >
                            <p className="bold" style={{ fontSize: 12 }}>
                              Kepada:
                            </p>
                            <p className="mb-0" style={{ fontSize: 13 }}>
                              {data?.customer?.company_name || data?.customer?.name}
                            </p>
                            <p className="" style={{ fontSize: 11, lineHeight: 1.5 }}>
                              {data?.customer?.address || '-'}
                            </p>
                          </td>

                          <td
                            style={{
                              textAlign: 'left',
                              width: '25%',
                            }}
                          ></td>
                          <td
                            style={{
                              textAlign: 'left',
                              width: '35%',
                              padding: 10,
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                              }}
                            >
                              <p className="bold mb-0" style={{ fontSize: 12 }}>
                                INVOICE #
                              </p>
                              <p>{data?.code}</p>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                              }}
                            >
                              <p className="bold mb-0" style={{ fontSize: 12 }}>
                                INVOICE DATE
                              </p>
                              <p>{formatDate(data?.schedule_at, 'DD/MM/YYYY')}</p>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                              }}
                            >
                              <p className="bold mb-0" style={{ fontSize: 12 }}>
                                INVOICE DUE DATE
                              </p>
                              <p>{formatDate(data?.due_at, 'DD/MM/YYYY')}</p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </>
                )}

                <div style={{ marginTop: 30 }}>
                  <table className="body ">
                    <thead className="" style={{ backgroundColor: '#2f83ba' }}>
                      <tr style={{ verticalAlign: 'center' }}>
                        <td
                          className="center tb-spacing"
                          style={{
                            padding: 5,
                            width: '5%',
                          }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 12 }}
                          >
                            No.
                          </p>
                        </td>
                        <td
                          className="left tb-spacing"
                          style={{ width: '15%' }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 12 }}
                          >
                            Kode Order
                          </p>
                        </td>
                        <td
                          className="left tb-spacing"
                          style={{ width: '16%' }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 12 }}
                          >
                            Tipe Layanan
                          </p>
                        </td>
                        <td
                          className="left tb-spacing"
                          style={{ width: '16%' }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 12 }}
                          >
                            Alamat Pickup
                          </p>
                        </td>
                        <td
                          className="right tb-spacing"
                          style={{ width: '16%', padding: 5 }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 12 }}
                          >
                            Total Harga
                          </p>
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      {p?.map((d, i) => (
                        <tr key={i} style={{ verticalAlign: 'center' }}>
                          <td
                            className="center bordered tb-spacing"
                            style={{
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                          >
                            <p className="mb-0">
                              {id > 1
                                ? limit + (firstPage * (id - 1) + i + 1)
                                : firstPage * id + i + 1}
                            </p>
                          </td>
                          <td
                            className="left bordered tb-spacing"
                            style={{
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                          >
                            <p className="bold mb-0">{d?.code}</p>
                          </td>
                          <td
                            className="left bordered tb-spacing"
                            style={{
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                          >
                            <p className="mb-0 text-capitalize">
                              {d?.service_type?.name}
                            </p>
                          </td>
                          <td
                            className="left bordered tb-spacing"
                            style={{
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                          >
                            <div className="table-col">
                              <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                                {d?.pickup_address?.name}
                              </div>
                              <small className="info text-uppercase">
                                {d?.pickup_address?.region?.district_name},{' '}
                                {d?.pickup_address?.region?.regency_name}
                              </small>
                            </div>
                          </td>
                          <td
                            className="right bordered tb-spacing"
                            style={{
                              paddingTop: 10,
                              paddingBottom: 10,
                              paddingRight: 5,
                            }}
                          >
                            <p className=" mb-0">
                              {currencyFormat(d?.total_charges, 'IDR')}
                            </p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {page?.length === id + 1 && (
                  <>
                    <div style={{ marginTop: 10, lineHeight: 0 }}>
                      <table>
                        <tr style={{ verticalAlign: 'top' }}>
                          <td style={{ width: '50%' }}>
                            <table className="body" style={{ marginTop: 10 }}>
                              <tr>
                                <td>
                                  <p className="bold" style={{ fontSize: 12 }}>
                                    Catatan:{' '}
                                  </p>
                                </td>
                              </tr>
                              <tr className="" style={{ verticalAlign: 'top' }}>
                                <td><p className="mb-0">{data?.note}</p></td>
                              </tr>
                            </table>
                          </td>
                          <td style={{ width: '50%' }}>
                            <table>
                              <tr style={{ verticalAlign: 'center' }}>
                                <td className="right" style={{ width: '50%' }}>
                                  <p className="bold mb-0" style={{ fontSize: 12 }}>
                                    Subtotal
                                  </p>
                                </td>
                                <td
                                  className="right"
                                  style={{
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    paddingRight: 5,
                                  }}
                                >
                                  <p className="bold mb-0" style={{ fontSize: 12 }}>
                                    {currencyFormat(data?.subtotal, 'IDR')}
                                  </p>
                                </td>
                              </tr>
                              <tr style={{ verticalAlign: 'center' }}>
                                <td className="right" style={{ width: '50%' }}>
                                  <p className="bold mb-0" style={{ fontSize: 12 }}>
                                    Diskon
                                  </p>
                                </td>
                                <td
                                  className="right"
                                  style={{
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    paddingRight: 5,
                                  }}
                                >
                                  <p className="bold mb-0" style={{ fontSize: 12 }}>
                                    {currencyFormat(data?.discount, 'IDR')}
                                  </p>
                                </td>
                              </tr>
                              {data?.additional_charges && (
                                <tr style={{ verticalAlign: 'center' }}>
                                  <td className="right" style={{ width: '50%' }}>
                                    <p className="bold mb-0" style={{ fontSize: 12 }}>
                                      Biaya Tambahan
                                    </p>
                                  </td>
                                  <td
                                    className="right"
                                    style={{
                                      paddingTop: 10,
                                      paddingBottom: 10,
                                      paddingRight: 5,
                                    }}
                                  >
                                    <p className="bold mb-0" style={{ fontSize: 12 }}>
                                      {currencyFormat(data?.additional_charges, 'IDR')}
                                    </p>
                                  </td>
                                </tr>
                              )}

                              {data?.ppn && (
                                <tr style={{ verticalAlign: 'center' }}>
                                  <td className="right" style={{ width: '50%' }}>
                                    <p className="bold mb-0" style={{ fontSize: 12 }}>
                                      PPN
                                    </p>
                                  </td>
                                  <td
                                    className="right"
                                    style={{
                                      paddingTop: 10,
                                      paddingBottom: 10,
                                      paddingRight: 5,
                                    }}
                                  >
                                    <p className="bold mb-0" style={{ fontSize: 12 }}>
                                      {currencyFormat(data?.ppn_nominal, 'IDR')} {`(${data?.ppn} %)`}
                                    </p>
                                  </td>
                                </tr>
                              )}

                              <tr style={{ verticalAlign: 'center' }}>
                                <td className="right" style={{ width: '50%' }}>
                                  <p className="bold mb-0" style={{ fontSize: 12 }}>
                                    Total Penagihan
                                  </p>
                                </td>
                                <td
                                  className="right"
                                  style={{
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    paddingRight: 5,
                                  }}
                                >
                                  <p className="bold mb-0" style={{ fontSize: 12 }}>
                                    {currencyFormat(data?.total_charges, 'IDR')}
                                  </p>
                                </td>
                              </tr>
                              <tr style={{ verticalAlign: 'center' }}>
                                <td className="right" style={{ width: '50%' }}>
                                  <p className="bold mb-0" style={{ fontSize: 12 }}>
                                    Total Dibayarkan
                                  </p>
                                </td>
                                <td
                                  className="right"
                                  style={{
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    paddingRight: 5,
                                  }}
                                >
                                  <p className="bold mb-0" style={{ fontSize: 12 }}>
                                    {currencyFormat(data?.total_paid, 'IDR')}
                                  </p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div style={{ marginTop: 20 }}>
                      <table className="body">
                        <tr className="">
                          <td className="" style={{ width: '33%' }}>
                            <p className="bold mb-0 style={{ fontSize: 12 }}">
                              Informasi Pembayaran{' '}
                            </p>
                          </td>
                          <td className="" style={{ width: '33%' }}></td>
                          <td className="center" style={{ width: '33%' }}>
                            <p className="mb-0" style={{ fontSize: 12 }}>
                              Regards,
                            </p>
                          </td>
                        </tr>
                        <tr className="" style={{ verticalAlign: 'top' }}>
                          <td className="" style={{ width: '33%', height: 80 }}>
                            <p className="mb-0">Transfer Via:</p>
                            <p className="bold mb-0"> {client?.bank_account}</p>
                          </td>
                          <td className="" style={{ width: '33%', height: 80 }}></td>
                          <td
                            className=""
                            style={{ width: '33%', height: 80, padding: 0 }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'stretch',
                                textAlign: 'center',
                              }}
                            >
                              <p
                                className="bold"
                                style={{ marginBottom: 70, fontSize: 8 }}
                              ></p>
                              <p
                                className="mb-0 bold"
                                style={{ fontSize: 8, textDecoration: 'underline' }}
                              >
                                Nama / TTD / Stempel
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </>
                )}

                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '20px 60px',
                  }}
                >
                  <table
                    border="0"
                    style={{ borderCollapse: 'collapse', borderColor: '#000' }}
                    cellSpacing="0"
                    cellPadding="5"
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{ width: '50%', color: 'black', fontSize: 12 }}
                        ></td>
                        <td
                          style={{
                            width: '50%',
                            color: '#999',
                            fontSize: 12,
                            textAlign: 'right',
                          }}
                        >
                          <p
                            style={{
                              marginBlockEnd: 0,
                              marginBlockStart: 0,
                            }}
                          >
                            POWERED BY
                            <img
                              src={logo}
                              alt=""
                              height="15px"
                              style={{ marginLeft: 5 }}
                            />
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            ))}
          </>
        )}
      />
    </div>
  );
};

export default PrintInvoice;
